import { User } from "oidc-client-ts";
import "../types/authStorage";

export abstract class UserAuthState {
  static getStorageKey(): string {
    const authority = process.env.REACT_APP_AUTH_AUTHORITY;
    const clientId = process.env.REACT_APP_AUTH_CLIENT_ID;
    const storageKey = `wisdom-auth.user:${authority}:${clientId}`;

    return storageKey;
  }
  public static get(): User | undefined {
    const storageKey = this.getStorageKey();
    const userAuthInStorage = window.authStorage?.getItem(storageKey);

    if (!!userAuthInStorage) {
      const user = User.fromStorageString(userAuthInStorage);
      return user;
    }
    return undefined;
  }

  public static set(userAuth: any): void {
    const storageKey = this.getStorageKey();
    window.authStorage?.setItem(storageKey, JSON.stringify(userAuth));
  }

  public static getAccessToken(): string | undefined {
    const userAuth = this.get();

    if (!!userAuth) {
      return userAuth.access_token;
    }

    return undefined;
  }
}
